import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Modal, Row } from "antd";

import moment from "moment";

import { partialJustificationsService } from "./../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
	UIUpload,
} from "./../../components";

class Show extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onClose: PropTypes.func.isRequired,
		external: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			uuid: 0,
			item: {},
			general_key: null
		};
	}

	onOpen = (uuid, key) => {
		this.setState({
			isLoading: true,
			uuid: uuid,
			item: {},
			general_key: key,
		});

		partialJustificationsService.show({ uuid })
			.then((response) => {
				let item = response.data;
				this.setState({
					isLoading: false,
					item: item,
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	resetFields = () => {
		this.setState({
			item: {},
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	render() {
		const { visible } = this.props;
		const { uuid, isLoading, item } = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				showBtnSave={false}
				icon={<i className="fal fa-clipboard-list" />}
				title="Visualizar justificativa parcial"
				subtitle="Consulte as informações da justificativa parcial.">
				<Form layout="vertical">
					<UIFormSection
						icon={<i className="fal fa-users" />}
						title="Aplicar para"
						description="Empresas, departamentos e funcionários que recebem a justificativa.">
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Empresa(s)">
									{item.empresas?.length > 0 ?
										item.empresas.map((empresa, index) => {
											return <span key={empresa.id}>{empresa.nome} {index < item.empresas?.length - 1 ? <br /> : ""}</span>;
										})
										: "Todas"}
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item label="Departamento(s)">
									{item.departamentos?.length > 0 ?
										item.departamentos.map((departamento, index) => {
											return <span key={departamento.id}>{departamento.nome} {index < item.departamentos?.length - 1 ? <br /> : ""}</span>;
										})
										: "Todos"}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24}>
								<Form.Item label="Funcionário(s)">
									{item.funcionarios?.length > 0 ?
										item.funcionarios.map((funcionario, index) => {
											return <span key={funcionario.id}>{funcionario.nome} {index < item.funcionarios?.length - 1 ? <br /> : ""}</span>;
										})
										: "Todos"}
								</Form.Item>
							</Col>
						</Row>
					</UIFormSection>
					<UIFormSection
						icon={<i className="fal fa-clock" />}
						title="Justificativa"
						description="Motivo, data e horário justificado.">
						<Row gutter={16}>
							<Col xs={24}>
								<Form.Item label="Justificativa">
									{item.justificativa?.nome ?? "-"}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} sm={12}>
								<Form.Item label="Status">
									<span className={`status-tag ${item.status ? "status-tag-success" : "status-tag-error"}`}>
										<i className="status-tag-dot" />
										{item.status ? "Ativo" : "Inativo"}
									</span>
								</Form.Item>
							</Col>
							<Col xs={24} sm={12}>
								<Form.Item label="Data">
									{item.data ? moment(item.data).format("DD/MM/YYYY") : "-"}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} sm={12}>
								<Form.Item label="Hora início">
									{item.hora_inicio?.substr(0, 5) ?? "-"}
								</Form.Item>
							</Col>
							<Col xs={24} sm={12}>
								<Form.Item label="Hora fim">
									{item.hora_fim?.substr(0, 5) ?? "-"}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} sm={12}>
								<Form.Item label="Criação">
									{item.created_at ? moment(item.created_at).calendar() : "-"}
								</Form.Item>
							</Col>
							<Col xs={24} sm={12}>
								<Form.Item label="Última atualização">
									{item.updated_at ? moment(item.updated_at).calendar() : "-"}
								</Form.Item>
							</Col>
						</Row>
					</UIFormSection>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Show;
